import React from "react";
import AssetLeadForm from "forms/AssetLeadCreateForm";
import PropTypes from "prop-types";

import Modal, { ModalBody, ModalHeader } from "components/Modal";
import Translate from "utils/translate";

const { t } = new Translate("AssetLeadModal");

const AssetLeadModal = ({ onClose, onSubmit }) => (
  <Modal onClose={onClose} isOpen>
    <ModalHeader onClose={onClose}>{t("title")}</ModalHeader>
    <ModalBody>
      <AssetLeadForm onSubmit={onSubmit} />
    </ModalBody>
  </Modal>
);

AssetLeadModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default AssetLeadModal;
